import { useRef } from 'react';
const TOUCH_MOVE_THRESHOLD = 8;
export const useTouchSuggestion = (selectItem) => {
    const touchStartRef = useRef(null);
    const hasTouchMovedRef = useRef(false);
    const handleSuggestionTouchStart = (e) => {
        const touch = e.touches[0];
        if (!touch)
            return;
        touchStartRef.current = {
            x: touch.clientX,
            y: touch.clientY,
        };
        hasTouchMovedRef.current = false;
    };
    const handleSuggestionTouchMove = (e) => {
        const touch = e.touches[0];
        const touchStart = touchStartRef.current;
        if (!touch || !touchStart)
            return;
        const deltaX = Math.abs(touch.clientX - touchStart.x);
        const deltaY = Math.abs(touch.clientY - touchStart.y);
        if (deltaX > TOUCH_MOVE_THRESHOLD || deltaY > TOUCH_MOVE_THRESHOLD) {
            hasTouchMovedRef.current = true;
        }
    };
    const handleSuggestionTouchEnd = (item) => {
        if (!hasTouchMovedRef.current) {
            selectItem(item);
        }
        touchStartRef.current = null;
        hasTouchMovedRef.current = false;
    };
    const handleSuggestionTouchCancel = () => {
        touchStartRef.current = null;
        hasTouchMovedRef.current = false;
    };
    return {
        handleSuggestionTouchStart,
        handleSuggestionTouchMove,
        handleSuggestionTouchEnd,
        handleSuggestionTouchCancel,
    };
};
